import React, { useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useStore } from "../context/StoreContext";
import { t } from "../lib/i18n";
import { ProductCard } from "../components/store/ProductCard";
import { Input } from "../components/ui/input";
import { Search } from "lucide-react";

export default function Products() {
  const { lang } = useStore();
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [query, setQuery] = useState("");
  const category = params.get("category") || "";

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data));
  }, []);

  useEffect(() => {
    const p = {};
    if (category) p.category = category;
    if (query) p.q = query;
    api.get("/products", { params: p }).then((r) => setProducts(r.data));
  }, [category, query]);

  const activeCat = useMemo(() => categories.find((c) => c.id === category), [categories, category]);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-8 py-10 md:py-14">
      <div className="mb-8">
        <h1 className={`${lang === "ar" ? "font-arabic-heading" : "font-english-heading"} text-4xl md:text-5xl font-semibold`} style={{ color: "var(--thiqa-primary)" }}>
          {activeCat ? (lang === "ar" ? activeCat.name_ar : activeCat.name_en) : t(lang, "all_products")}
        </h1>
      </div>

      <div className="mb-8 flex flex-col md:flex-row gap-3">
        <div className="relative flex-1">
          <Search size={16} className="absolute top-3 start-3 text-gray-400" />
          <Input
            data-testid="search-input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t(lang, "search")}
            className="ps-10 rounded-full"
          />
        </div>
        <div className="flex gap-2 overflow-x-auto pb-1">
          <button
            data-testid="cat-filter-all"
            onClick={() => setParams({})}
            className={`px-4 py-2 rounded-full text-xs whitespace-nowrap border transition ${
              !category ? "bg-[color:var(--thiqa-primary)] text-white border-transparent" : "bg-white border-gray-200 hover:border-[color:var(--thiqa-primary)]"
            }`}
          >
            {lang === "ar" ? "الكل" : "All"}
          </button>
          {categories.map((c) => (
            <button
              key={c.id}
              data-testid={`cat-filter-${c.id}`}
              onClick={() => setParams({ category: c.id })}
              className={`px-4 py-2 rounded-full text-xs whitespace-nowrap border transition ${
                category === c.id ? "bg-[color:var(--thiqa-primary)] text-white border-transparent" : "bg-white border-gray-200 hover:border-[color:var(--thiqa-primary)]"
              }`}
            >
              {lang === "ar" ? c.name_ar : c.name_en}
            </button>
          ))}
        </div>
      </div>

      {products.length === 0 ? (
        <div className="text-center py-20 text-gray-500">{lang === "ar" ? "لا توجد منتجات" : "No products found"}</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-testid="products-grid">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
